import { useContext } from 'react'
import { ErrorFlowContext } from '@context/ErrorFlowContext/errorFlow.context'
import { useParams } from 'react-router-dom'
import useGetOpenOrders from './useGetOpenOrders'
import { B2CGetOpenOrdersQuery } from 'parkdepot-shared/gql/graphql'
import { ApolloError } from '@apollo/client'
import { ErrorFlow } from '@customTypes/errorFlow.interface'
import { CarpayOrderActionsStep } from '@components/CarpayOrderActions/CarpayOrderActions.component'

const useCarpayOrder = (
    plate: string | null
): {
    data: B2CGetOpenOrdersQuery | undefined | null
    loading: boolean
    errorFlowData: ErrorFlow | null
    error: ApolloError | undefined | null
} => {
    const { order_id } = useParams<{ order_id: string }>()
    const { errorFlow } = useContext(ErrorFlowContext)

    const isErrorFlow = order_id === CarpayOrderActionsStep.ErrorFlow

    const { data, loading, error } = useGetOpenOrders({
        skip: !plate || isErrorFlow,
        variables: { plates: [plate!] },
        fetchPolicy: 'cache-first'
    })

    return {
        data,
        loading: isErrorFlow ? false : loading,
        error,
        errorFlowData: isErrorFlow ? errorFlow : null
    }
}

export default useCarpayOrder
